import { Host, h } from '@stencil/core';
export class AibaSelfieSteps {
  constructor() {
    this.handleCloseConfirmBox = e => {
      this.handlers && this.handlers.closeModalhandler(e);
    };
    this.data = undefined;
    this.styles = undefined;
    this.handlers = undefined;
  }
  async handleButtonClick(e, eventName) {
    if (this.handlers && this.handlers[eventName]) {
      this.handlers[eventName](e);
    }
  }
  componentDidRender(e) {
    var _a, _b;
    this.handlers && ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.handleSelfieStepsDidrender) && ((_b = this.handlers) === null || _b === void 0 ? void 0 : _b.handleSelfieStepsDidrender(e));
  }
  render() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    if (typeof this.data === 'string') {
      this.data = JSON.parse(this.data);
    }
    return (h(Host, null, ((_c = (_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.modal) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.styles) && h("style", null, (_f = (_e = (_d = this.data) === null || _d === void 0 ? void 0 : _d.modal) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.styles), h("aiba-modal", { modalPosition: (_j = (_h = (_g = this.data) === null || _g === void 0 ? void 0 : _g.modal) === null || _h === void 0 ? void 0 : _h.data) === null || _j === void 0 ? void 0 : _j.modalPosition, handleClick: this.handleCloseConfirmBox, closeButtonData: (_m = (_l = (_k = this.data) === null || _k === void 0 ? void 0 : _k.modal) === null || _l === void 0 ? void 0 : _l.data) === null || _m === void 0 ? void 0 : _m.closeButtonData, handlers: this.handlers }, this.data &&
      ((_o = this.data) === null || _o === void 0 ? void 0 : _o.elements.map((component) => {
        var _a;
        if (component && component['name'] === 'aiba-label') {
          return h("aiba-label", Object.assign({}, component['data']));
        }
        if (component && component['name'] === 'aiba-button') {
          return h("aiba-button", Object.assign({}, component['data'], { handleClick: (e) => this.handleButtonClick(e, component['data']['handleClick']) }));
        }
        if (component && component['name'] === 'aiba-content-block') {
          return h("aiba-content-block", Object.assign({}, component, { handlers: this === null || this === void 0 ? void 0 : this.handlers }));
        }
        if (component && component['name'] === 'aiba-content-block-divs') {
          h("div", { class: "selfie-tips-bottom-half-wrapper" }, component['data'] &&
            ((_a = component['data']) === null || _a === void 0 ? void 0 : _a.elements.map((elem) => {
              if (elem && elem['name'] === 'aiba-content-block') {
                return h("aiba-content-block", Object.assign({}, elem));
              }
            })));
        }
      })))));
  }
  static get is() { return "aiba-selfie-steps"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-selfie-steps.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-selfie-steps.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "styles": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
}
//# sourceMappingURL=aiba-selfie-steps.js.map
